import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { ModelGenerationFormFields } from "../_components/model-generation-form-fields";

export function ModelGenerationCreateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:CreateModel");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ModelGenerationFormFields />
    </CenteredLayout>
  );
}
